export default __webpack_public_path__ + "static/media/expense manager icon.ef4fd4f1.svg";